import type { ReactNode } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardBody } from '@vnetwork/ui/primitives';

/**
 * A titled Card section used to lay out the single-page contract-create form.
 * Keeps every section visually consistent with the rest of the @workspace app
 * (Card + CardHeader/CardTitle + CardBody grid).
 */
export function SectionShell({
  title,
  description,
  actions,
  children,
}: {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Card>
      <CardHeader actions={actions}>
        <CardTitle>{title}</CardTitle>
        {description ? <CardDescription>{description}</CardDescription> : null}
      </CardHeader>
      <CardBody style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>{children}</CardBody>
    </Card>
  );
}

/** A responsive auto-fit grid for form fields inside a section. */
export function FieldGrid({ children, min = 240 }: { children: ReactNode; min?: number }) {
  return (
    <div
      style={{
        display: 'grid',
        gap: 'var(--vn-space-4)',
        gridTemplateColumns: `repeat(auto-fit, minmax(${min}px, 1fr))`,
      }}
    >
      {children}
    </div>
  );
}
